import "./PageHeader.css";
import React from "react";

type PageHeaderProps = {
    title: string;
    subtitle?: string;
    info?: React.ReactNode;
};

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, info }) => {
    return (
        <div className="header">
            <div className="header-main">
                <div className="header-title">
                    <div className="header-title-text">{title}</div>
                    {subtitle && <div className="header-subtitle-text">{subtitle}</div>}
                </div>

                {/* only render the box if info exists */}
                {info && <div className="header-info">{info}</div>}
            </div>
        </div>
    );
};

export default PageHeader;
